import { render, staticRenderFns } from "./EllipsLink.vue?vue&type=template&id=f505fc18&"
import script from "./EllipsLink.vue?vue&type=script&lang=ts&"
export * from "./EllipsLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports